export const texts = {
  title: 'Update your preferences',
  message: "Change your dietary or recipe preferences and we'll show recipes we think you'll love",
  buttonText: 'Update preferences',
}
